<template>
    <div v-if="extensions.length !== 0"
         v-tooltip="'Show enabled extension hints'"
         class="custom-control custom-switch mt-1">
        <input class="custom-control-input" type="checkbox"
               :value="showExtensionHints"
               :checked="showExtensionHints"
               @change="setShowExtensionHints(!showExtensionHints)"
               id="showExtensionsHint">
        <label class="custom-control-label pt-1"
               for="showExtensionsHint">
            {{ label }}
        </label>
    </div>
</template>

<script>
import {DOC_SETTINGS_SET_SHOW_EXTENSION_HINTS} from '../../../../../store/modules/doc-viewer/settings'
import {mapGetters, mapMutations} from 'vuex'

export default {
    name: 'DocumentViewerExtensionHintsToggle',
    props: {
        label: {
            type: String,
            default: 'Extension hints'
        }
    },
    computed: {
        ...mapGetters('doc_viewer_settings', [
            'extensions',
            'showExtensionHints'
        ])
    },
    methods: {
        ...mapMutations('doc_viewer_settings', {
            setShowExtensionHints: DOC_SETTINGS_SET_SHOW_EXTENSION_HINTS
        })
    }
}
</script>
<style lang="scss">
    label {
        font-weight: 500;
        color: #2c3e50 !important;
        margin-bottom: 2px;
    }

    </style>
